const headers = {
  name: "Supplier Outstanding Statement",
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search by PO number or supplier",
      value: "",
    },
    {
      type: "range",
      name: "date",
      placeholder: ["Start Date", "End Date"],
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Suppliers",
        path: "/app/suppliers",
      },
      {
        name: "Outstanding Statement",
        path: "",
      },
       {
        name: "Clearing Balances",
        path: "/app/suppliers/clearing-balance",
      },
    ],
  },
};

export default headers;